export default __webpack_public_path__ + "static/media/construction.bcff9224.jpg";